export type BattleResultType = 'win' | 'loss' | 'draw';

export interface EloTier {
    name: string;
    minElo: number;
    icon: 'pawn' | 'knight' | 'bishop' | 'rook' | 'king';
    color: string;
}

export const ELO_TIERS: EloTier[] = [
    { name: 'Serf', minElo: 0, icon: 'pawn', color: '#a8a29e' },
    { name: 'Man-at-Arms', minElo: 1200, icon: 'pawn', color: '#78716c' },
    { name: 'Squire', minElo: 1400, icon: 'knight', color: '#60a5fa' },
    { name: 'Knight', minElo: 1600, icon: 'knight', color: '#3b82f6' },
    { name: 'Knight Captain', minElo: 1800, icon: 'bishop', color: '#8b5cf6' },
    { name: 'Baron', minElo: 2000, icon: 'bishop', color: '#a855f7' },
    { name: 'Viscount', minElo: 2200, icon: 'rook', color: '#f87171' },
    { name: 'Earl', minElo: 2400, icon: 'rook', color: '#ef4444' },
    { name: 'Duke', minElo: 2600, icon: 'king', color: '#fbbf24' },
    { name: 'Grand Marshal', minElo: 2800, icon: 'king', color: '#f59e0b' },
];

export const getEloTier = (rating: number): EloTier => {
    // Find highest tier where rating >= minElo
    return [...ELO_TIERS].reverse().find(t => rating >= t.minElo) || ELO_TIERS[0];
};

export const calculateEloChange = (
    playerRating: number,
    opponentRating: number,
    result: BattleResultType,
    kFactor: number = 32
): number => {
    const expectedScore = 1 / (1 + Math.pow(10, (opponentRating - playerRating) / 400));

    let actualScore = 0;
    if (result === 'win') actualScore = 1;
    else if (result === 'draw') actualScore = 0.5;

    const change = Math.round(kFactor * (actualScore - expectedScore));
    return change;
};
